import styled, { keyframes, css } from "styled-components";
import { Dialog, Card } from "@material-ui/core";

const showLeft = keyframes`
from {
  opacity: 1;
    transform: rotateY(0);
    transform-origin: left;
}

to {
  opacity: 0;
    transform: rotateY(100deg);
    transform-origin: left;
}
`;

const showRight = keyframes`
from {
  opacity: 1;
    transform: rotateY(0);
    transform-origin: right;
}

to {
  opacity: 0;
    transform: rotateY(-100deg);
    transform-origin: right;
}
`;

export const ContainerDialog = styled(Dialog)`
  .MuiDialogContent-root {
    display: flex;
    padding: 0;
  }

  .MuiDialogContent-root:first-child {
    padding-top: 0;
    overflow: hidden;
  }



  .MuiPaper-elevation {
    display: none;
  }
  @media (max-width: 767px) AND (orientation: portrait) {
    .MuiDialog-paper {
      max-height: 100vh;
      width: 100vw;
      height: 100vh;
      margin: 0;
    }
    .MuiDialogContent-root {
      overflow-y: hidden;
      padding-top: 10px;
      align-items: center;
    }
    .MuiPaper-elevation {
      display: block;
      box-shadow: none;
      background-color: #fff;
      color: #666666;
    }
  }

  @media (max-width: 900px) AND (orientation: landscape) {
    .MuiDialog-paper {
      max-height: 100vh;
      width: 100vw;
      height: 100vh;
      margin: 0;
    }
    .MuiDialogContent-root {
      overflow-y: hidden;
      padding-top: 10px;
      align-items: center;
    }
    .MuiPaper-elevation {
      display: block;
      box-shadow: none;
      background-color: #fff;
      color: #666666;
    }
  }


`;


export const ContainerLogin = styled.div`
  display:flex;
  
  @media screen and (max-width:850px){
    flex-direction:column;
  }

`;

export const FormContainer = styled.div`
  z-index: 2;
  background-color: #ffffff;
  min-height: 200px;
  width: 100%;
  padding: 28px 18px;
  transition: transform 0.8s ease-in-out;
  transform: translateX(0);
  ${({ left, active }) => left && !active && css`
  transform: translateX(10%);
  z-index: 1;
  animation: ${showRight} 2s;
  `}
  ${({ left, active }) => !left && !active && css`
  transform: translateX(-10%);
  z-index: 1;
  animation: ${showLeft} 2s;
  `}
  //overflow: hidden;
  > .form {
    display: flex;
    min-height: 100%;
    flex-direction: column;
    padding: 15px 30px;
    justify-content: center;
    gap: 10px;
    transition: transform 0.8s ease-in-out;
    overflow: scroll ;
    > .title {
      font-size: 2em !important;
      font-weight: bold;
      text-align: center;
      color: #666666;
      margin-bottom: 10px;
    }
    .columns {
      display: flex;
      gap: 20px;
      > .MuiFormControl-root {
        width: 50%;
      }
    }
    .btnOlvidaContrasenia {
      align-self: start;
      margin-bottom: 15px;
    }
    .btnSubmit {
      font-weight: bold;
      padding: 10px 20px;
      letter-spacing: 1px;
      transition: transform 0.8ms ease-in;
      border-radius: 20px;
      border: 1px solid #f1b585;
      background-color: #f1b585;
      max-width: 80%;
      align-self: center;
    }
    .btnMobile {
      display: none;
      font-weight: bold;
      padding: 10px 20px;
      letter-spacing: 1px;
      transition: transform 0.8ms ease-in;
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-color: #ffffff;
      color: #f1b585 !important;
      width: 100%;
      align-self: center;
    }
    .MuiFormHelperText-root {
      font-size: 11px !important;
    }
  }
  @media (max-width: 767px) AND (orientation: portrait) {
    background: white;
    padding: 0;
    transition: transform 0.8s ease-in-out;
    opacity: 1;
    height: 100vh;
    overflow: auto;
    ${({ left, active }) => left && !active && css`
    flex: 1;
    transform: translateX(-40%);
    z-index: 1;
    animation: ${showRight} 0.8s;
    opacity: 0.5;
    `}
    ${({ left, active }) => !left && !active && css`
    flex: 1;
    transform: translateX(40%);
    z-index: 1;
    animation: ${showLeft} 0.8s;
    opacity: 0.5;
    `}
    > .form {
      //height: ${({ left }) => left ? "90%" : "auto"};
      min-height: 100% ;
      transition: transform 0.8s ease-in-out;
      padding-bottom: 60px;
      .columns {
        transition: transform 0.8s ease-in-out;
        flex-wrap: wrap;
        gap: 10px;
        > .MuiFormControl-root {
          width: 100% !important;
        }
      }
      .btnMobile {
        display: block;
        color: #666666;
      }
      .btnOlvidaContrasenia {
        margin-bottom: 0px;
      }
      .btnSubmit {
        max-width: 100%;
        width: 100%;
        padding: 10px 8px;
        margin-bottom: 8px;
      }
    }
  }
  @media (max-width: 900px) AND (orientation: landscape) {
    background: white;
    padding: 0;
    transition: transform 0.8s ease-in-out;
    opacity: 1;
    height: 100vh;
    overflow: auto;
    ${({ left, active }) => left && !active && css`
    flex: 1;
    transform: translateX(-40%);
    z-index: 1;
    animation: ${showRight} 0.8s;
    opacity: 0.5;
    `}
    ${({ left, active }) => !left && !active && css`
    flex: 1;
    transform: translateX(40%);
    z-index: 1;
    animation: ${showLeft} 0.8s;
    opacity: 0.5;
    `}
    > .form {
      //height: ${({ left }) => left ? "90%" : "auto"};
      min-height: 100% ;
      transition: transform 0.8s ease-in-out;
      padding-bottom: 60px;
      .columns {
        transition: transform 0.8s ease-in-out;
        flex-wrap: wrap;
        gap: 10px;
        > .MuiFormControl-root {
          width: 100% !important;
        }
      }
      .btnMobile {
        display: block;
        color: #666666;
      }
      .btnOlvidaContrasenia {
        margin-bottom: 0px;
      }
      .btnSubmit {
        max-width: 100%;
        width: 100%;
        padding: 10px 8px;
        margin-bottom: 8px;
      }
    }
  }
`;

export const FormOverlay = styled.div`
  position: absolute;
	width: 50%;
	height: 100%;
	overflow: hidden;
	transition: transform 0.8s ease-in-out;
	z-index: 100;
  min-height: 200px;
  transform: ${({ isLogin }) => isLogin ? "translateX(100%)" : "translateX(0)"};
  > .overlay {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    background-color: #f1b585/*#F5A796*/;
    background: -webkit-linear-gradient(to bottom, #F5A796, #F1B585);
    background: linear-gradient(to bottom, #F5A796, #F1B585);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
    color: #FFFFFF;
    transform: translateX(0);
    height: 100%;
    transition: transform 0.8s ease-in-out;
    padding: 45px;
    .title {
      font-size: 2em !important;
      font-weight: bold;
      text-align: center;
      color: #fff;
    }
    .MuiTypography-root {
      text-align: center;
    }
    .btnInfo {
      font-weight: bold;
      padding: 8px 20px;
      letter-spacing: 1px;
      transition: transform 80ms ease-in;
      border-radius: 20px;
      border: 1px solid #fff;
      background-color: #fff;
      max-width: 80%;
      min-width: 200px;
      align-self: center;
      color: #666666;
    }
  }
  @media (max-width: 767px) and (orientation: portraitgit){
    display: none;
  }

  @media screen and (max-width: 767px) {
    display: none !important;
  }
  @media (max-width: 900px) and (orientation: landscape) {
    display: none;
  }

  @media (max-width: 900px) and (orientation: landscape) {
    display: none;
  }

`;